import React, { ReactNode } from 'react';

import { Radio as RadioCore } from 'antd';

interface IRadioProps {
	value: string | number;
	children?: ReactNode;
	className?: string;
}

const Radio = (props: IRadioProps) => {
	const { children, ...restProps } = props;
	return <RadioCore {...restProps}>{children}</RadioCore>;
};

export default Radio;
